import React from 'react'
import { ListItem } from '@mui/material'
import BulletList from './bullet-list'
import Plan from './plan'
import { formatDate } from './util'

const SuspensionDetails = ({ suspension, 'data-test': testAttr }) => {
  return (
    <BulletList data-test={testAttr}>
      <ListItem data-test={`${testAttr}-start`}>
        Suspension starts <strong>{formatDate(suspension.start)}</strong>
      </ListItem>
      <ListItem data-test={`${testAttr}-end`}>
        Suspension ends <strong>{formatDate(suspension.end)}</strong>
      </ListItem>
    </BulletList>
  )
}

const SuspendedPlan = ({ suspension }) => {
  return (
    <Plan
      panel={
        <SuspensionDetails
          suspension={suspension}
          data-test='retention-plan-suspension'
        />
      }
    />
  )
}

export default SuspendedPlan
